import { ApiServiceBase } from './ApiServiceBase'

export default class extends ApiServiceBase {
  async index() {
    return useAsyncData('influencer-categories-index', () => this.call('/spa/influencer/categories'), {
      lazy: true,
      deep: false,
    })
  }
}
